import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
import axios from "axios";
import { withAccessToken } from "src/server/api";
import { Chat } from "../api/chatApi";
import { handleUnreadMessage } from "./conversation";
import { CONVERSATIONTEMPORARY } from "../../variable/constant";
import { v4 } from "uuid";
axios.defaults.baseURL = process.env.REACT_APP_FINAN_DOMAIN;

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  openNoti: true,
  participants: [],
  orderItem: [],
  products: [],
  chatHistory: [],
  receiverType: "business",
  isTyping: false,
  senderType: "user",
  messageIn: null,
  renderOnMobile: null,
  conversationUtils: {},
  chatHistoryTemporary: [],
  isExistConversation: true,
  isEmpty: false,
};

const getChatTime = (arr) => {
  let clone = [...arr];
  if (arr.length === 1) {
    return arr;
  }
  const data = arr.reduce((accum, i, index) => {
    const isToday = moment(i.created_at).isSame(moment(), "day");
    const content = isToday
      ? moment(i.created_at).format("HH:mm")
      : moment(i.created_at).format("HH:mm · DD-MM-YYYY");
    if (index - 1 >= 0) {
      const date2 = moment(arr[index - 1]?.created_at, "YYYYMMDD");
      const date1 = moment(i.created_at, "YYYYMMDD");
      const diff = date1.diff(date2, "days");

      if (diff > 0) {
        let idex = clone.findIndex((item) => item.id === i.id);
        clone.splice(idex, 0, {
          id: v4(),
          message: content,
          created_at: i.created_at,
          message_type: "time",
        });
      }
    } else {
      clone.splice(0, 0, {
        id: v4(),
        message: content,
        created_at: i.created_at,
        message_type: "time",
      });
    }
    accum = [...clone];
    return accum;
  }, []);

  return data;
};

export const objFromArray = (array, key = "id") => {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
};

const uniqueArray = (array) => {
  const uniqueArray = array.filter(
    (value, index, arr) =>
      arr.findIndex((value2) => value2.id === value.id) === index
  );

  return uniqueArray;
};

const slice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },

    hasDone(state, action) {
      state.isLoading = false;
    },

    // GET PARTICIPANTS

    setChatHistoryTemporary(state, action) {
      const { payload } = action;
      state.chatHistoryTemporary = payload;
    },

    setRenderconversationPresentId(state, action) {
      const { payload } = action;
      state.renderconversationPresentId = payload;
    },

    setConversationUtils(state, action) {
      const { payload } = action;
      state.conversationUtils = payload;
    },

    setMessageIn(state, action) {
      const { payload } = action;
      state.messageIn = payload;
    },

    getOrderChildSuccess(state, action) {
      const { payload } = action;
      state.orderItem = {
        ...state.orderItem,
        ...objFromArray(payload, "order_number"),
      };
    },

    getProductChildSuccess(state, action) {
      const { payload } = action;
      state.products = {
        ...state.products,
        ...objFromArray(payload, "id"),
      };
    },
    // GET HISTORY CHAT
    getHistoryChatSuccess(state, action) {
      const { payload } = action;
      const sortData = (payload.data || []).reverse();
      const data = getChatTime([...sortData]);
      const isDuplicate =
        [...data, ...state.chatHistory].length -
          uniqueArray([...data, ...state.chatHistory]).length <
        10;

      const check =
        (state.chatHistory || state.isConversationPresent) &&
        state.isExistConversation &&
        isDuplicate;

      if (check) {
        state.chatHistory = uniqueArray([...data, ...state.chatHistory]);
      } else if (sortData?.length === 0) {
        state.chatHistory = uniqueArray([...data, ...state.chatHistory]);
      } else {
        state.isExistConversation = true;
        state.chatHistory = uniqueArray([...data]);
      }
      state.metaMessageList = payload.meta;
      state.isEmpty = sortData?.length === 0 ? true : false;
    },

    updateReceiverType(state, action) {
      const { payload } = action;
      state.receiverType = payload;
    },
    updateSenderType(state, action) {
      const { payload } = action;
      state.senderType = payload;
    },

    updateMetaMessageList(state, action) {
      const { payload } = action;
      state.metaMessageList = payload;
    },

    updateIsTyping(state, action) {
      const { payload } = action;
      state.isTyping = payload;
    },

    updatePage(state, action) {
      const { payload } = action;
      state.page = payload;
    },

    setIsExistConversation(state, action) {
      const { payload } = action;
      state.isExistConversation = payload;
    },

    updateChat(state, action) {
      const { payload } = action;
      if (state.conversationPresentId) {
        state.chatHistory = payload;
      } else {
        state.chatHistory = payload;
      }
    },
    clearChat(state, action) {
      state.chatHistory = [];
    },
    updateChatSC(state, action) {
      const { payload } = action;

      state.chatHistory.push(payload[0]);

      state.isTyping = true;
      state.messageIn.check = false;
    },

    openNotiLogin(state, action) {
      const { payload } = action;
      state.openNoti = payload;
    },

    setRenderOnMobile(state, action) {
      const { payload } = action;
      state.renderOnMobile = payload;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function setChatHistoryTemporary(chatHistory) {
  return (dispatch) => {
    dispatch(slice.actions.setChatHistoryTemporary(chatHistory));
  };
}

export function setRenderconversationPresentId(renderconversationPresentId) {
  return (dispatch) => {
    dispatch(
      slice.actions.setRenderconversationPresentId(renderconversationPresentId)
    );
  };
}

export function getProductChildSuccess(arrayProduct) {
  return (dispatch) => {
    dispatch(slice.actions.getProductChildSuccess(arrayProduct));
  };
}

export function getOrderChildSuccess(arrayOrder) {
  return (dispatch) => {
    dispatch(slice.actions.getOrderChildSuccess(arrayOrder));
  };
}

export function setIsExistConversation(isExistConversation) {
  return (dispatch) => {
    dispatch(slice.actions.setIsExistConversation(isExistConversation));
  };
}

export async function getOrder(order) {
  try {
    const config = await withAccessToken({
      "Content-Type": "application/json;charset=UTF-8",
    });
    const response = await Chat.getOneOrder(
      {
        headers: config,
      },
      order
    );

    if (Object.keys(response?.data).length > 0) {
      return response?.data;
    }
  } catch (error) {
    console.log(error);
  }
}

export async function getProduct(idProduct) {
  try {
    const config = await withAccessToken({
      "Content-Type": "application/json;charset=UTF-8",
    });
    const response = await Chat.getOneProduct(
      {
        headers: config,
      },
      idProduct
    );

    if (Object.keys(response?.data).length > 0) {
      return response?.data;
    }
  } catch (error) {
    console.log(error);
  }
}

export function getReceiverType(receiverType) {
  return (dispatch) => {
    dispatch(slice.actions.updateReceiverType(receiverType));
  };
}

export function setUpdateSenderType(senderType) {
  return (dispatch) => {
    dispatch(slice.actions.updateSenderType(senderType));
  };
}

export function getUpdateMetaMessageList(metaMessageList) {
  return (dispatch) => {
    dispatch(slice.actions.updateMetaMessageList(metaMessageList));
  };
}

export function setIsTyping(isTyping) {
  return (dispatch) => {
    dispatch(slice.actions.updateIsTyping(isTyping));
  };
}

export function setPage(page) {
  return (dispatch) => {
    dispatch(slice.actions.updatePage(page));
  };
}

export function setConversationUtils(conversationUtils) {
  return (dispatch) => {
    dispatch(slice.actions.setConversationUtils(conversationUtils));
  };
}

export function setRenderOnMobile(renderOnMobile) {
  return (dispatch) => {
    dispatch(slice.actions.setRenderOnMobile(renderOnMobile));
  };
}

export function setMessageIn(message) {
  return (dispatch) => {
    dispatch(slice.actions.setMessageIn(message));
  };
}

export function getHistoryChat(params) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const config = await withAccessToken({
        "Content-Type": "application/json;charset=UTF-8",
      });
      const response = await Chat.getHistoryChat({
        params: params,
        headers: config,
      });
      Promise.all(
        response?.data.map((item) => {
          if (item.message_type === "order") {
            return getOrder(item.message);
          }
        })
      )
        .then((responses) => {
          const orders = responses.filter(
            (response) => response && { response }
          );
          dispatch(slice.actions.getOrderChildSuccess(orders ?? []));
        })
        .catch((error) => {
          dispatch(slice.actions.hasError(error));
        });

      Promise.all(
        response?.data.map((item) => {
          if (item.message_type === "product") {
            return getProduct(item.message);
          }
        })
      )
        .then((responses) => {
          const products = responses.filter(
            (response) => response && { response }
          );

          dispatch(slice.actions.getProductChildSuccess(products ?? []));
        })
        .catch((error) => {
          dispatch(slice.actions.hasError(error));
        });

      dispatch(slice.actions.getHistoryChatSuccess(response));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    } finally {
      dispatch(slice.actions.hasDone());
    }
  };
}
export function clearHistoryChat() {
  return (dispatch) => {
    dispatch(slice.actions.clearChat());
  };
}

export function updateChatHistory(chat) {
  return (dispatch) => {
    dispatch(slice.actions.updateChat(chat));
  };
}
export function updateTest({
  chat,
  businessId,
  list_conversation,
  conversationPresentId,
  idChatCurrent,
}) {
  return (dispatch) => {
    Promise.all(
      chat?.map((item) => {
        if (item.body.type === "order") {
          return getOrder(item.body.content);
        }
      })
    )
      .then((responses) => {
        const orders = responses.filter((response) => response && { response });
        dispatch(slice.actions.getOrderChildSuccess(orders ?? []));
      })
      .catch((error) => {
        dispatch(slice.actions.hasError(error));
      });

    Promise.all(
      chat?.map((item) => {
        if (item.body.type === "product") {
          return getProduct(item.body.content);
        }
      })
    )
      .then((responses) => {
        const products = responses.filter(
          (response) => response && { response }
        );

        dispatch(slice.actions.getProductChildSuccess(products ?? []));
      })
      .catch((error) => {
        dispatch(slice.actions.hasError(error));
      });

    let indexRemove = null;
    const isExistConversation =
      list_conversation &&
      list_conversation.find((value, index) => {
        indexRemove = index;
        return value.id === chat[0]?.body?.conversation_id;
      });

    dispatch(setIsExistConversation(isExistConversation));

    dispatch(
      handleUnreadMessage({
        chat,
        businessId,
        conversationPresentId,
        isExistConversation,
        indexRemove,
        idChatCurrent,
      })
    );
    // chat[0].userChatbusinessIdInit = userChatbusinessIdInit;

    if (
      chat[0]?.body?.conversation_id ===
      (conversationPresentId || list_conversation?.[0].id)
    ) {
      dispatch(slice.actions.updateChatSC(chat));
    }
  };
}

export function openNotiLogin(is_open) {
  return (dispatch) => {
    dispatch(slice.actions.openNotiLogin(is_open));
  };
}
